module.exports = __webpack_public_path__ + "static/media/spc.47047256.webp";